import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApplicationCandidateProps } from "./model";

export const ApplicationCandidateItem = ({ data }: any) => {
  var props = data as ApplicationCandidateProps;
  const navigate = useNavigate();
  const [showPhoto, setShowPhoto] = useState(false);

  const onItemClick = (id: string) => {
    if (props.status !== "COMPLETED" && props.status !== "EMPLOYER_REFUSED" && props.status !== "CANDIDATE_REFUSED" && props.status !== "EXPIRED")
      navigate(`/applications/${id}`);
  };

  const getStatus = () => {
    switch (props.status) {
      case "PENDING":
        return props.type === "APPLICATION" ? "Așteaptă răspuns" : "Se așteaptă răspuns de la candidat";
      case "IN_PROGRESS":
        return "În lucru";
      case "AWAITING_FEEDBACK":
        return "Lasă feedback";
      case "COMPLETED":
        return "Finalizat";
      case "EMPLOYER_REFUSED":
        return "Refuzat de angajator";
      case "CANDIDATE_REFUSED":
        return "Refuzat de candidat";
      case "EXPIRED":
        return "Invitație expirată";
      default:
        return "";
    }
  };

  const getFormattedPrice = () => {
    if (props.confidentialRate || props.rate == null) return "Confidențial";
    if (props.rateType === "DAY") return `${props.rate} Lei / Zi`;
    if (props.rateType === "HOUR") return `${props.rate} Lei / Oră`;
    if (props.rateType === "GROSS") return `${props.rate} Lei brut`;
    if (props.rateType === "NET") return `${props.rate} Lei net`;
    return `${props.rate} Lei`;
  };

  const getFormattedDate = () => {
    return new Date(props.dateFrom).toLocaleDateString("ro-RO", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  };

  return (
      <>
        {showPhoto && props.profilePictureUrl && (
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
                onClick={() => setShowPhoto(false)}
            >
              <img
                  src={props.profilePictureUrl}
                  alt={`${props.firstName} ${props.lastName}`}
                  className="max-h-[80vh] max-w-[80vw] rounded-[16px] object-contain shadow-xl"
                  onClick={(e) => e.stopPropagation()}
              />
            </div>
        )}

      <div
          className="candidate-item mt-[12px] sm:mt-[16px] cursor-pointer"
          id={props.id}
          onClick={() => onItemClick(props.id)}
      >
        <div className="flex justify-between items-start sm:items-center">
          <div className="flex flex-1 min-w-0">
            <div className="w-[42px] h-[42px] sm:w-[66px] sm:h-[66px] bg-figmaLightBg rounded-full flex flex-shrink-0">
              <div className="h-[38px] w-[38px] sm:h-[64px] sm:w-[64px] rounded-full bg-figmaSpecialBlue bg-opacity-25 m-auto flex items-center justify-center">
                {props && props.profilePictureUrl != null ? (
                    <img
                        alt=""
                        src={props.profilePictureUrl}
                        className="h-[38px] w-[38px] sm:h-[64px] sm:w-[64px] object-cover rounded-full"
                        onClick={(e) => { e.stopPropagation(); setShowPhoto(true); }}
                    />
                ) : (
                    <p className="text-[12px] sm:text-[14px]">
                      {props.firstName[0]}{props.lastName[0]}
                    </p>
                )}
              </div>
            </div>

            <div className="ml-[12px] sm:ml-[16px] flex-1 min-w-0">
              <p className="candidate-item-name text-[14px] sm:text-base truncate">{props.gigTitle}</p>
              <p className="text-figmaPrimary text-[11px] sm:text-[12px]">
                {props.firstName} {props.lastName}
              </p>

              <div className="flex flex-wrap mt-[6px] sm:mt-[8px] items-center gap-x-[8px] gap-y-[4px]">
                <div className="flex items-center">
                  <img alt="" src="/images/navigation.svg" className="w-[12px] h-[12px] sm:w-auto sm:h-auto" />
                  <p className="text-figmaDarkGray text-[11px] sm:text-[12px] ml-[2px] truncate max-w-[80px] sm:max-w-none">
                    {props.location}
                  </p>
                </div>

                <div className="flex items-center">
                  <img alt="" src="/images/calendar-icon.svg" className="w-[12px] h-[12px] sm:w-auto sm:h-auto" />
                  <p className="text-figmaDarkGray text-[11px] sm:text-[12px] pl-[4px]">
                    {getFormattedDate()}
                  </p>
                </div>

                <div className="flex items-center">
                  <img alt="" src="/images/ic-dollar.svg" className="w-[12px] h-[12px] sm:w-auto sm:h-auto" />
                  <p className="text-figmaDarkGray text-[11px] sm:text-[12px] pl-[4px]">
                    {getFormattedPrice()}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-shrink-0 ml-[8px]">
            <p className="candidate-item-rating text-[11px] sm:text-[12px] text-right">{getStatus()}</p>
          </div>
        </div>
      </div>
      </>
  );
};